import { en } from "./en";
import { ja } from "./ja";

const appBar = {
  en,
  ja
}

export default appBar;